var React = require('react');

function ArrowInline (props) {
    return React.createElement("svg",props,React.createElement("polygon",{"points":"28.37,8.09 6.82,8.28 6.84,21.89 28.39,21.69 28.4,25.21 37.69,14.88 28.37,4.57 "}));
}

ArrowInline.defaultProps = {"version":"1.1","id":"Design","x":"0px","y":"0px","viewBox":"0 0 42.11 29.55","style":{"enableBackground":"new 0 0 42.11 29.55"},"xmlSpace":"preserve"};

module.exports = ArrowInline;

ArrowInline.default = ArrowInline;
